import { AssignmentResponse } from "shared/types/teacherTypes"
import * as teacher from "shared/routes/teacher"
import { TextbookProductType } from "shared/types/curriculumTypes"
import { HomeSchoolBlock } from "shared/types/homeschoolTypes"

interface Props {
    classID: string
    textbookProduct?: TextbookProductType
    homeschoolBlocks?: HomeSchoolBlock[]
}

export default async function getFilteredAssignments ({ classID, textbookProduct, homeschoolBlocks }: Props): Promise<AssignmentResponse[]> {
    const assignments = await teacher.getAssignments({ classID, targetHomeschoolBlocks: homeschoolBlocks })
    return assignments.filter((assigment) => {
        if (textbookProduct) {
            return assigment.lessonVariety === "Topic"
        } else {
            return assigment.lessonVariety === "Guided" || assigment.lessonVariety === "Pure Inquiry"
        }
    })
}